import { DragEventHandler, DragEvent } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset, kuiperClassNames } from '@opallabs/kuiper'
import { GalleryPosition } from '../positions'
import { styles } from './styles'

const onDragOver: DragEventHandler = (e) => e.preventDefault()

interface Props {
  asset: AssetReference
  dragZone: number | null
  hasAssetOptions: boolean
  isDragging: boolean
  isTooltipActive: boolean
  isPresenting: boolean
  onDragComplete: DragEventHandler
  onDragEnter: DragEventHandler
  onDragStart: (e: DragEvent<HTMLDivElement>, asset: AssetReference) => void
  onExpandAsset: (assetId: number) => void
  onRemoveAsset: (assetId: number) => void
  readOnly: boolean
  maxHeight: number
  maxWidth: number
  style: GalleryPosition
  updateCaption: (value: string, assetId: number) => void
  zone: number
}

export const DraggableAsset: React.FC<Props> = ({
  asset,
  dragZone,
  hasAssetOptions,
  isDragging,
  isTooltipActive,
  isPresenting,
  maxHeight,
  maxWidth,
  style,
  onDragComplete,
  onDragEnter,
  onDragStart,
  onExpandAsset,
  onRemoveAsset,
  readOnly,
  updateCaption,
  zone,
}) => (
  <div
    data-zone-id={zone}
    draggable={true}
    onDragStart={(e): void => onDragStart(e, asset)}
  >
    <div
      className={kuiperClassNames('draggable-area')}
      data-zone-id={zone}
      css={styles.getDragAreaStyling(
        maxHeight,
        maxWidth,
        style,
        isDragging,
        dragZone === zone
      )}
      onDragOver={onDragOver}
      onDrop={onDragComplete}
      onDragEnter={onDragEnter}
    />
    <Asset
      imageFit="cover"
      hasAssetOptions={hasAssetOptions}
      hasAssetOverlay={
        asset && (!readOnly || isPresenting) && !isTooltipActive && !isDragging
      }
      assetReference={asset}
      placeholder={true}
      removeable={!isPresenting}
      updateCaption={updateCaption}
      overrideStyles={{
        assetBase: styles.getImgStyling(maxHeight, maxWidth, style),
      }}
      onEmbiggen={(): void => onExpandAsset(asset.id || 0)}
      onRemove={(): void => onRemoveAsset(asset.id || 0)}
    />
  </div>
)
